import { required } from "@itk/react-form";
import { Loading } from "@itk/typescript-utils";
import { Model_AttributeFilterPut, Model_AttributeGet } from "src/backend/openapi/v1";

type TAttributeFilterValidity = {
  attribute: Model_AttributeGet;
  selectedValue: string | null;
  error: string | undefined;
  isValid: boolean;
};

// one entry per attribute the server matched (attributeEntityKind=FilterAttribute, attributeType=List,
// attributeEntityFilterId=<product type>) - there can legitimately be more than one attribute scoped to the
// same product type (e.g. Color and Material both filtering the same product type), so every matched attribute
// gets its own independent selection/validation, not just the first
export const getProductFilterValidities = (attributesState: Loading<Model_AttributeGet[]>, attributeFilters: Model_AttributeFilterPut[] | null | undefined): TAttributeFilterValidity[] => {
  if (attributesState.loading !== "has-loaded") return [];

  return attributesState.data.map(attribute => {
    const selectedValue = attributeFilters?.find(filter => filter.attributeId === attribute.attributeId)?.value ?? null;
    const error = attribute.isRequired ? required(selectedValue) : undefined;
    return { attribute, selectedValue, error, isValid: !error };
  });
};
